import { Field } from 'formik';
import styled from 'styled-components/macro';

export const ToggleSwitchWrapper = styled.label`
  position: relative;

  display: flex;

  & input {
    width: 0;
    height: 0;

    opacity: 0;
  }
`;

export const ToggleSwitchSlider = styled.span<{ disabled?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;

  width: 2rem;
  height: 1.25rem;
  padding: 0.125rem 0.857rem 0.125rem 0.143rem;
  border-radius: 1.125rem;

  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.black_10 : theme.colors.black_60};

  cursor: pointer;

  transition: 0.2s;
  &::before {
    position: absolute;

    width: 1rem;
    height: 1rem;
    border: 0.5px solid ${({ theme }) => theme.colors.black_10};
    border-radius: 50%;

    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);

    content: '';
  }
`;

export const ToggleSwitchInput = styled(Field)`
  &:checked + ${ToggleSwitchSlider} {
    background-color: ${({ theme }) => theme.colors.primary};
  }
  &:checked + ${/* sc-sel */ ToggleSwitchSlider}:before {
    background-color: ${({ theme }) => theme.colors.white};
    transform: translateX(0.75rem);
  }
  &:disabled + ${ToggleSwitchSlider} {
    background-color: ${({ theme }) => theme.colors.black_10};
  }
`;

export const ToggleSwitchText = styled.span<{ disabled?: boolean }>`
  padding-left: ${({ theme }) => theme.spacing.two_2};

  color: ${({ theme, disabled }) => (disabled ? theme.colors.black_40 : theme.colors.black_80)};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;
